// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


/* ==========================================================================
   Shop
   ========================================================================== */


const settings = {
    ajaxTriggerUpdateSelector: '.wc-layered-nav-term a, .woocommerce-pagination a', // these triggers will start the ajax refresh.
    ajaxUpdateContainerSelectors: ['.js-shop-dropdown--filters .shop__filters__inner', '.shop__products', '.js-shop-dropdown--sort .shop__filters__inner',], // these parts of the page will be updated
};


export default class Shop {


    constructor () {
        this.setCache();
        this.ajaxifyFilters();
        this.ajaxifySort();
    }

    setCache() {
        this.cache = {};
        this.cache.body = $(document.body);
    }

    // make the woocommerce order/sort widget work with ajax.
    ajaxifySort() {

        // turn off woocommerce default functionality.
        $('.woocommerce-ordering').off();

        // add our own listener
        this.cache.body.on('change', '.woocommerce-ordering', (e) => {

                var data = $(e.target).closest('form').serialize();

                this.addLoaders();
                this.isLoading(true);

                // Request for next page.
                // window.location.href.split('?')[0]
                $.post( '?' + data).then(

                    (response) => {
                        // on success
                        this.updateHtml(response);
                        // this.updateURL(url);
                        this.isLoading(false);
                    },
                    (response) => {
                        // on failure
                        this.isLoading(false);
                        this.cache.body.trigger('error');
                    }

                    );
        });
    }

    // make the woocommerce layered nav widgets/pagination work with ajax.
    ajaxifyFilters() {

        this.cache.body.on('click', settings.ajaxTriggerUpdateSelector, (e) => {

            e.preventDefault();

            var target = $(e.target);
            var url = target.attr('href');

            $('html,body').animate({scrollTop:0}, 1000);

            target.blur();

            this.addLoaders();
            this.isLoading(true);

            $.ajax({
                type:     'GET',
                url:      url,
                dataType: 'html',
            }).then(

            (response) => {
                // on success
                this.updateHtml(response);
                this.updateURL(url);
                this.isLoading(false);
            },

            (response) => {
                // on failure
                this.isLoading(false);
                this.cache.body.trigger('error');
            } );

        });

    }

    ajaxifyAddToCart() {

    }

    updateHtml(response) {
        settings.ajaxUpdateContainerSelectors.forEach((selector) => {
            this.cache.body.find(selector).replaceWith($(response).find(selector));
        });

        this.cache.body.trigger('shop_html_did_update');
    }

    updateURL(url) {
        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, url);
        }
    }

    addLoaders() {
        $("<div class='loader'><div class='loader__inner'></div></div>").appendTo(settings.ajaxUpdateContainerSelectors);
    }

    isLoading(isLoading = true) {
        $((settings.ajaxUpdateContainerSelectors).join()).toggleClass('is-loading', isLoading);
        this.cache.body.toggleClass('is-loading-shop', isLoading);
    }

}
